"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = void 0;
var DialogFooter_1 = __importDefault(require("./DialogFooter"));
exports.DialogFooter = DialogFooter_1.default;
exports.default = DialogFooter_1.default;
//# sourceMappingURL=index.js.map